import { FieldReviewTable } from '../fieldReviewTable';
// import { SpecialConditionsList } from '../specialConditions/specialConditionsList';

export interface PurchaseContractReviewTableProps {
  data: Record<string, any>;
}

export const PurchaseContractReviewTable = ({ data }: PurchaseContractReviewTableProps) => {
  return (
    <>
      <FieldReviewTable items={data?.items} />
      {/*
        Special Conditions UI is parked pending business review of what the field
        should surface. The backend still extracts and stores specialConditions, so
        no data is lost while this is off - only the rendering is disabled.
        Re-enable by uncommenting this and the import above, plus the matching
        blocks in purchaseContractEditModal.tsx and purchaseContractFormStore.ts.

        <SpecialConditionsList conditions={data?.specialConditions} />
      */}
    </>
  );
};
